import Page from '../../../../router/pages';

export const getAuthPageUrl = ({
  redirectedFrom,
}: {
  redirectedFrom: string;
}) => {
  if (!redirectedFrom) {
    return Page.auth;
  }

  const searchParams = new URLSearchParams({
    redirectedFrom,
  });

  return `${Page.auth}?${searchParams.toString()}`;
};

export const readRedirectedFromParam = (searchParams: URLSearchParams) =>
  searchParams.get('redirectedFrom');
